import { SwitchSize } from './types';

export const SizeMap: Record<
  SwitchSize,
  { height: number; width: number; handleDiameter: number }
> = {
  [SwitchSize.Small]: {
    width: 24,
    height: 14,
    handleDiameter: 12,
  },
  [SwitchSize.Big]: {
    width: 48,
    height: 28,
    handleDiameter: 24,
  },
};
